<script setup>
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid";
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

const props = defineProps({
    column: String,
    modelValue: Object,
    class: String,
    sortable: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

const isColumnSorted = computed(() => {
    if (props.modelValue?.order === undefined) {
        return false;
    }

    return props.modelValue?.order === props.column;
});

const isSortedAsc = computed(() => {
    if (isColumnSorted.value) {
        return props.modelValue?.direction !== "desc";
    }
    return false;
});

const updateSort = () => {
    if (!props.sortable) {
        return;
    }

    if (isColumnSorted.value) {
        if (isSortedAsc.value) {
            emit("update:modelValue", {
                order: undefined,
                direction: undefined,
            });
        } else if (!isSortedAsc.value) {
            emit("update:modelValue", {
                order: props.column,
                direction: "asc",
            });
        } else {
            emit("update:modelValue", {
                order: props.column,
                direction: "desc",
            });
        }
    } else {
        emit("update:modelValue", {
            order: props.column,
            direction: "desc",
        });
    }
};
</script>

<template>
    <th scope="col" :class="twMerge('pl-0 pr-8 py-2 font-semibold', props.class)">
        <div :class="[' ', sortable ? 'inline-flex items-center group cursor-pointer' : '']" @click="updateSort()">
            <slot></slot>
            <template v-if="sortable">
                <span v-if="isColumnSorted" class="flex-none ml-2 text-gray-600 bg-gray-100 rounded dark:text-gray-400 dark:bg-gray-800">
                    <ChevronUpIcon v-if="isSortedAsc" class="w-5 h-5" aria-hidden="true" />
                    <ChevronDownIcon v-else class="w-5 h-5" aria-hidden="true" />
                </span>
                <span v-else class="invisible flex-none ml-2 text-gray-600 rounded dark:text-gray-400 group-focus:visible group-hover:visible">
                    <ChevronUpIcon v-if="isSortedAsc" class="w-5 h-5" aria-hidden="true" />
                    <ChevronDownIcon v-else class="w-5 h-5" aria-hidden="true" />
                </span>
            </template>
        </div>
    </th>
</template>
